import { IllustrationProps } from 'fe-design-base/assets/types';
import Box from 'fe-design-base/atoms/Box';

import square_clock from './imageFiles/square_clock.png';

const SquareClock = (props: IllustrationProps) => (
  <Box
    w={72}
    {...props}
    minw={72}
    className={`FDBIllustration${
      props?.className ? ` ${props.className}` : ''
    }`}
  >
    <img
      src={square_clock}
      style={{ width: '100%' }}
      alt="Square Clock Illustration"
    />
  </Box>
);
export default SquareClock;
